<div class="modal-header">
  <div class="d-flex justify-content-between align-items-center w-100">
    <div>&nbsp;&nbsp;&nbsp;</div>
    @if (currentStep === 0) {
      <h4 class="text-center fw-semibold fs-6 m-0 text-black">{{ 'widget.buy_now' | translate }}</h4>
    }
    @if (currentStep === 1) {
      <h4 class="text-center fw-semibold fs-6 m-0 text-black">{{ 'wert.title' | translate }}</h4>
    }
    <svg-icon src="/assets/images/svg-icons/close-black.svg" [svgStyle]="{ 'width.px': 14, 'height.px': 14 }" class="cursor-pointer" (click)="modalRef.hide()"></svg-icon>
  </div>
</div>

@if (currentStep === 0) {
  <div class="modal-body text-center">
    <p class="text-white">{{ 'wert.disclaimer' | translate: { token } }}</p>
    <button (click)="showWidget()" class="btn btn-primary bg-white text-black font-14 mt-2 mx-auto">{{ 'wert.continue' | translate }}</button>
  </div>
}

@if (currentStep === 1) {
  <div class="modal-body text-center">
    <img src="/assets/images/svg-icons/logo.svg" alt="loading" class="worker" loading="lazy" />
    <p translate class="text-white">{{ 'wert.desc' | translate }}</p>
  </div>
}
